import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, Building2, User } from 'lucide-react';

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const goToDashboard = () => {
    if (user?.role === 'broker') {
      navigate('/broker/dashboard');
    } else if (user?.role === 'company') {
      navigate('/company/dashboard');
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-100 h-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-full flex items-center justify-between">
        <button
          onClick={() => navigate('/')}
          className="font-display text-2xl font-bold text-slate-900 tracking-tight"
          data-testid="logo-button"
        >
          Atlas.
        </button>

        <div className="flex items-center gap-4">
          {user ? (
            <>
              <button
                onClick={goToDashboard}
                className="flex items-center gap-2 text-slate-600 hover:text-slate-900 px-4 py-2 rounded-lg hover:bg-slate-100 smooth-transition"
                data-testid="dashboard-button"
              >
                {user.role === 'broker' ? <User className="w-4 h-4" /> : <Building2 className="w-4 h-4" />}
                <span className="font-medium capitalize">{user.role}</span>
              </button>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 text-slate-600 hover:text-slate-900 px-4 py-2 rounded-lg hover:bg-slate-100 smooth-transition"
                data-testid="logout-button"
              >
                <LogOut className="w-4 h-4" />
                <span className="font-medium">Logout</span>
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate('/auth')}
              className="bg-slate-900 text-white rounded-lg px-6 py-2 font-medium hover:bg-slate-800 smooth-transition shadow-sm"
              data-testid="login-button"
            >
              Login
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};